import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaEllipsisVertical } from "react-icons/fa6";
import { MdControlPoint, MdDelete, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { toast } from "react-toastify";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminHeader from "../../components/CommonComponents/AdminHeader";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import { getItemToken } from "../../Utils/localStorageUtils";
import AdminCustomButton from "../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import { IconDeleteFigma, IconEditFigma } from "../../Assets/MyIcons";
import MessageBox from "../../components/CommonComponents/MessageBox";
import AdminCustomArea from "../../components/CommonComponents/AdminCustomArea";
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import { IoMdInformationCircle } from "react-icons/io";
import FieldRenderer2 from "../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../CustomFields/saveCustomFieldsStrict";

const FAQ = () => {
  const baseURL = process.env.REACT_APP_Baseurl
  const userAccessToken = getItemToken('access_token');
  const labelSource = 'faq-page'

  const deleteApi = `${baseURL}/admin/faq/multi-delete`
  const getApi = `${baseURL}/admin/faq/index`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const addApi = `${baseURL}/admin/faq/store`
  const editApi = `${baseURL}/admin/faq/edit`
  const updateApi = `${baseURL}/admin/faq/update`
  const createApi = `${baseURL}/admin/faq/create`


  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [modelCloseAdd, setModelCloseAdd] = useState(false);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const combinedRef = useRef({
    genre_id: null,
    answer: null,
    question: null
  });

  const [formData, setFormData] = useState({
    genre_id: "",
    answer: "",
    question: ""
  })

  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    parentOption: [],
  })

  const [formDataError, setFormDataError] = useState({})

  const handleInput = (e) => {
    const { name, value, type } = e.target;
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === "textarea") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setItemToDelete([])
  };

  const openModal = () => {
    setModelClose(true);
  };

  const handleCloseEditModal = () => {
    setModelCloseAdd(!modelCloseAdd)
    setFormData((prev) => ({ devices_name: "" }))
    setFormDataError((prev) => ({ devices_name: "" }))
  }

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  const columns = [
    {
      dataField: "question",
      text: "FAQ QUESTION",

    },
    {
      dataField: "answer",
      text: "FAQ ANSWER",

    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) =>
        <div className="editdropdown ">
          <span className="editdropdown-button">
            <FaEllipsisVertical className="theme-text-color" />
          </span>
          <div className="editdropdown-menu theme-bg-color">
            <div onClick={() => handleEdit(row?.id)} className="commonActionPadding theme-bg-color"  >
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </div>
            <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color"  >
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
            </div>
          </div>
        </div>,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${getApi}`, { headers: userAccessToken });
      const result = response?.data?.AllAdminFAQ;
      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchCreate = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: userAccessToken });
      const result = response?.data;
      const defaultoptionslist = {
        parentOption: multiSelectLabel(result?.GenreFAQ, 'id', 'name'),
      }
      setDefaultOption(defaultoptionslist);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await axios.get(`${editApi}/${id}`, { headers: userAccessToken });
      const result = response?.data;
      if (result?.status) {
        setFormData(result?.FAQ);
        setModelCloseAdd(true);
        const defaultoptionslist = {
          parentOption: multiSelectLabel(result?.GenreFAQ, 'id', 'name'),
        }
        setDefaultOption(defaultoptionslist);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${deleteApi}`, {
        headers: userAccessToken,
        data: { id: [...itemToDelete] },
      });

      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: userAccessToken });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleStore = async () => {
    let formIsValid = true;
    let findApi = !formData?.id ? addApi : `${updateApi}/${formData?.id}`
    if (!formData?.question) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        question: "Question cannot be empty.",
      }));
      combinedRef.current['question'].focus()
      formIsValid = false;
    }
    if (!formData?.answer?.trim()) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        answer: "Answer cannot be empty.",
      }));
      combinedRef.current['answer'].focus();
      formIsValid = false;
    }
    if (!formData?.genre_id) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        genre_id: "Choose one of the genre.",
      }));
      combinedRef.current['genre_id'].focus()
      formIsValid = false;
      return
    }
    if (formIsValid) {
      setShowOverlay(true);
      try {
        const formDataAdd = {};
        for (const key in formData) {
          if (["question", "answer", "genre_id"].includes(key)) {
            formDataAdd[key] = formData[key]
          }
        }

        const response = await axios.post(findApi, formDataAdd, { headers: userAccessToken });
        const result = response?.data;
        if (result?.status) {
          // save custom field values (strict)
          try {
            const entityId = formData?.id || result?.FAQid || result?.FAQ?.id || result?.id;
            await saveCustomFieldsStrict({ baseURL, headers: userAccessToken, entityType: 'faq', entityId, values: customFieldValues });
          } catch (e) {
            setShowOverlay(false);
            toast.error(e?.message || 'Failed to save additional fields');
            return;
          }
          setShowOverlay(false);
          setWithoutRefresh(!withOutRefresh)
          toast.success(result?.message)
          setModelCloseAdd(false);
          setFormData((prev) => ({
            devices_name: ""
          }))
        }

      }
      catch (err) {
        setShowOverlay(false);
        const errorMessage = err?.response?.data?.message
        toast.error(errorMessage)
      }
    }
  }

  useEffect(async () => {
    await fetchData();
    await labelFetch()
    if (!formData?.id) {
      await fetchCreate()
    }
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <div className="d-flex align-items-center flex-wrap pb-3 ">
        <div className="col-md-6 col-12 ">
          <h4 className="admin-title mb-0 theme-text-color text-md-start">
            <MessageBox text={labelDisplay?.[0]?.title} classname="theme-text-color" />
            <span className="admin-sub-title theme-text-color ms-2">
              ( {apiData?.length}{' '}
              <MessageBox text="results found" classname="theme-text-color" /> )
            </span>
          </h4>
        </div>
        <div className="col-md-6 col-12 d-flex align-items-center justify-content-end mt-3 mt-sm-0" >
          {itemToDelete?.length > 0 && (
            <button className="warningColorBg p-2 rounded-2 d-inline-flex align-items-center " onClick={() => openModal()}>
              <MdDelete className="exportIcon me-1" fill="#fff" />
              <MessageBox text='Delete' classname='admin-button-text ' />
            </button>
          )}
          <button type="button" onClick={() => setModelCloseAdd(!modelCloseAdd)} className="admin-title ms-3 rounded-2 d-inline-flex align-items-center  text-decoration-hover  py-2 px-3"    >
            <MdControlPoint className="me-2 exportIcon text-white" style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text text-white" text={labelDisplay?.[1]?.title} />
          </button>
        </div>
      </div>
      <div className={`modal packageModel fade ${modelCloseAdd && "d-block show"}`} id="devices" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <MessageHeading text={!formData?.id ? labelDisplay?.[1]?.title : labelDisplay?.[5]?.title} className="mb-0 mb-sm-0 " border padding />
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleCloseEditModal()} ></button>
            </div>
            <div className="modal-body">
              <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
              <AdminCustomInput type="question" name="question" value={formData?.question} onChange={handleInput} placeHolder={"Enter your FAQ"} ref={(el) => (combinedRef.current.question = el)} error={formDataError?.question} />

              <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
              <AdminCustomArea type="text" name="answer" value={formData?.answer} onChange={handleInput} placeHolder={"Enter your FAQ answer"} ref={(el) => (combinedRef.current.answer = el)} error={formDataError?.answer} rows={5} maxlength={10000} />

              <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />

              <select name="genre_id" value={formData?.genre_id || 0} defaultValue={formData?.gender} onChange={handleInput} className="form-select mb-3 custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={(el) => (combinedRef.current.genre_id = el)}>
                <option value='' className="theme-bg-color theme-text-color" >Select a Genre</option>
                {defaultOption?.parentOption?.map((item, index) => {
                  return <option value={`${item?.value}`} className="theme-bg-color theme-text-color">{item?.label}</option>
                })}
              </select>

              <div className="card p-3 mt-3">
                {/* <MessageHeading text="Additional Fields" /> */}
                {/* Custom fields */}
                <FieldRenderer2
                  pageIdentifier={formData?.id ? "faq.edit" : "faq.create"}
                  entityType="faq"
                  entityId={formData?.id || null}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={formData?.id ? "faq.edit" : "faq.create"}
                  entityType="faq"
                  entityId={formData?.id || null}
                  onChange={setCustomFieldValues}
                />
              </div>
              {formDataError?.genre_id && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.genre_id}`} classname='errorred  d-block' /></div>)}
            </div>
            <div className="modal-footer">
              <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!formData?.id ? labelDisplay?.[1]?.title : labelDisplay?.[6]?.title} />
            </div>
          </div>
        </div>
      </div>
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader exportpage={true} searchMethod={handleFilterChange} reduceData={filteredData} originalData={apiData} fileName={"devices"} customDevices />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
      </div>
    </>
  );
}
export default FAQ;